export default (width = 24, height = 24) => `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
        <path fill="none" d="M-1-1h26v26H-1z"/><g><g transform="matrix(.99656 0 0 .99395 10.336 10.4)" fill-rule="evenodd" fill="none" stroke="null"><circle fill="#309A02" r="12" cy="1.579" cx="1.67"/><path stroke="#FFF" d="M-4.33 1.018L.39 5.579l8.28-8" stroke-width="2"/></g></g>
    </svg>
`